export default function TermsOfService() {
  return (
    <main className="legal-page">
      <div className="container legal-container">
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: February 2026</p>

        <section>
          <h2>About the App</h2>
          <p>
            Quit Gooning is a self-help tool designed to support individuals who
            want to track their progress in breaking unwanted habits. It is not a
            medical device, therapy replacement, or clinical tool.
          </p>
        </section>

        <section>
          <h2>No Medical Claims</h2>
          <p>
            This app does not diagnose, treat, cure, or prevent any medical or
            psychological condition. If you are struggling with addiction or
            mental health issues, please consult a qualified healthcare
            professional.
          </p>
        </section>

        <section>
          <h2>Use at Your Own Discretion</h2>
          <p>
            You are responsible for how you use this app. The app provides a
            simple tracking mechanism — what you do with that information is
            entirely up to you.
          </p>
        </section>

        <section>
          <h2>No Guarantees</h2>
          <p>
            We do not guarantee any specific outcomes from using this app. Personal
            change is a process that varies for each individual.
          </p>
        </section>

        <section>
          <h2>Subscriptions & Purchases</h2>
          <p>
            Quit Gooning offers the following pricing options to unlock premium features:
          </p>
          <ul className="legal-list">
            <li><strong>Monthly Subscription:</strong> $0.99/month</li>
            <li><strong>Yearly Subscription:</strong> $8.99/year</li>
            <li><strong>Lifetime Access:</strong> $14.99 one-time purchase</li>
          </ul>
          <p>
            Subscriptions automatically renew unless cancelled at least 24 hours
            before the end of the current billing period. You can manage or cancel
            your subscription at any time through your device's app store settings.
            Payment is charged to your App Store or Google Play account at
            confirmation of purchase.
          </p>
        </section>

        <section>
          <h2>Refunds</h2>
          <p>
            All purchases are processed through the Apple App Store or Google Play
            Store. Refund requests must be submitted directly through the respective
            store. We do not process refunds independently of these platforms.
          </p>
        </section>

        <section>
          <h2>Data Responsibility</h2>
          <p>
            Since all data is stored locally on your device, you are responsible
            for its safekeeping. We cannot recover data that has been lost or
            deleted.
          </p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>
          <p>
            We may update these terms from time to time. Changes will be
            reflected on this page.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            If you have any questions about these terms, please contact us at{' '}
            <a href="mailto:umairali2k181@gmail.com">umairali2k181@gmail.com</a>{' '}
            or call <a href="tel:+923098929098">+923098929098</a>.
          </p>
        </section>
      </div>
    </main>
  );
}
